import moment from "moment";
import {getProfileSettings} from "../config/localStorage";

export const UTC = "iso_utc";

moment.updateLocale("en", {
  relativeTime: {
    future: "in %s",
    past: "%s ago",
    s: "1 second",
    ss: "%d seconds",
    m: "1 minute",
    mm: "%d minutes",
    h: "1 hour",
    hh: "%d hours",
    d: "1 day",
    dd: "%d days",
    w: "1 week",
    ww: "%d weeks",
    M: "1 month",
    MM: "%d months",
    y: "1 year",
    yy: "%d years"
  }
});

/**
 * @param {unknown} maybeDate
 * @return {boolean}
 */
export function isISODate(maybeDate) {
  try {
    const isoDate = new Date(maybeDate).toISOString();
    return maybeDate === isoDate;
  } catch {
    return false;
  }
}

export function getFormattedDate(date, format) {
  if (!date) return undefined;

  const settings = getProfileSettings();
  const timezone = settings.timezone;

  if (timezone === UTC) {
    return getUTCDate(date);
  } else {
    return moment(date)
      .tz(timezone)
      .format(format ? format : settings.dateFormat);
  }
}

export function getUTCDate(date) {
  return date ? moment(date).toISOString() : undefined;
}

export function getSelectedTimezone() {
  const settings = getProfileSettings();
  const timezone = settings && settings.timezone;
  if (timezone) {
    return timezone === UTC ? "UTC" : timezone;
  }
  return "UTC";
}

/**
 * Displays relative time from a specified date, utilizing the timezone date
 * setting.
 *
 * @param {string} date UTC date string
 * @param {boolean} [removeSuffix=false] If true, "ago" suffix will be removed.
 * @returns {string} "5 days" or "3 months", etc.
 */
export const getTimeFromNow = (date, removeSuffix = false) => {
  const timezone = getSelectedTimezone();
  const dateWithTimezoneSetting = moment(date).tz(timezone, true);
  const convertedDate = dateWithTimezoneSetting.toDate();

  return moment(convertedDate).fromNow(removeSuffix);
};

/**
 * Compare startDate & endDate.
 * Return true if this is a valid date range.
 * ie. startDate is before endDate.
 * Return false otherwise
 *
 * @param {Date} startDate
 * @param {Date} endDate
 * @param {moment.unitOfTime.StartOf} granularity
 * @returns {boolean} is startDate before endDate
 */
export function startBeforeOREqualToEnd(
  startDate,
  endDate,
  granularity = "day"
) {
  if (startDate && endDate) {
    const startCheck = moment(startDate);
    const endCheck = moment(endDate);
    if (startCheck && endCheck) {
      return startCheck.isSameOrBefore(endCheck, granularity);
    }
  }
  return false;
}
